import { CONSOLE_ONLY, flagError } from 'error-handling'
import type Rollbar from 'rollbar'
import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin(nuxtApp => {
  let confettiInstance: any = null
  let confettiPromise: Promise<any | null> | null = null

  const getConfetti = () => {
    if (confettiInstance) return confettiInstance

    if (!confettiPromise) {
      confettiPromise = import('vue-confetti')
        .then(({ default: VueConfetti }) => {
          nuxtApp.vueApp.use(VueConfetti as any)
          confettiInstance = nuxtApp.vueApp.config.globalProperties.$confetti
          return confettiInstance
        })
        .catch(error => {
          const clientRollbar = nuxtApp.$rollbar as Rollbar | null
          flagError(error, '[confetti] Failed to load vue-confetti', clientRollbar ?? CONSOLE_ONLY)
          return null
        })
    }

    return confettiPromise
  }

  nuxtApp.vueApp.config.globalProperties.$confetti = {
    start: async (...args: any[]) => {
      const confetti = await getConfetti()
      confetti?.start?.(...args)
    },
    stop: async (...args: any[]) => {
      const confetti = await getConfetti()
      confetti?.stop?.(...args)
    },
  }
})
